<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="logo-container">
    <img height="60" src="../../../assets/duo-logo-green.png" alt="Cisco Duo Logo">
</div>

<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fSecret}}</mat-label>
                <input matInput id="secret_key" type="password" formControlName="secret_key" placeholder="{{fSecret}}" autocomplete="new-password">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fInt}}</mat-label>
                <input matInput id="integration_key" formControlName="integration_key" placeholder="{{fInt}}">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fHost}}</mat-label>
                <input matInput id="api_hostname" type="text" formControlName="api_hostname" placeholder="{{fHost}}">
            </mat-form-field>
        </div>

        <button type="button" (click)="cancel()" mat-raised-button>{{fCancel}}</button>
        <button id='save' color="primary" type="button" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{fSave}}</button>
        <!-- <button type="button" (click)="validate()" [disabled]="!formGroup.valid" mat-raised-button>Validate</button> -->

    </form>
</div>
